import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import radioConfig from "../config/radioConfig";

export const PartnerBlock = () => {
  return (
    <section id="partner" className="relative py-20 sm:py-28 bg-[#0D131E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl border border-emerald-500/30 bg-[#0F1B2A] p-8 sm:p-12 overflow-hidden"
        >
          <div className="absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-emerald-500/10 blur-[100px]" />

          <div className="relative flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex-1 text-center md:text-left">
              <p className="text-xs uppercase tracking-[0.25em] font-mono text-emerald-400 mb-4">
                También en Las Breñas
              </p>
              <a
                href={radioConfig.lasBrenasDigitalUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ir a Las Breñas Digital"
                className="inline-block bg-white rounded-xl px-5 py-4 mb-5 hover:scale-[1.02] transition-transform duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
              >
                <img
                  src={radioConfig.assets.lasBrenasDigitalLogo}
                  alt="Las Breñas Digital"
                  data-testid="partner-logo-image"
                  loading="lazy"
                  className="h-12 sm:h-14 w-auto object-contain"
                />
              </a>
              <h3 className="font-heading text-2xl sm:text-3xl font-bold text-white">
                Las Breñas Digital
              </h3>
              <p className="mt-2 text-slate-400 max-w-md">
                Noticias de Las Breñas y la región.
              </p>
            </div>

            <a
              href={radioConfig.lasBrenasDigitalUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="partner-visit-button"
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-[#070A0F] font-bold px-7 py-4 rounded-full transition-[background-color,transform] duration-200 hover:scale-[1.03] shadow-[0_0_36px_rgba(16,185,129,0.35)] focus:outline-none focus-visible:ring-2 focus-visible:ring-white whitespace-nowrap"
            >
              VISITAR EL PORTAL
              <ArrowUpRight size={18} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerBlock;
